import ScheduleAppointmentPage from "./ScheduleAppointmentPage";

export default ScheduleAppointmentPage;

export * from "./ScheduleAppointmentPage";
